import { render, staticRenderFns } from "./modal-sinisters-list.vue?vue&type=template&id=324b9216"
import script from "./modal-sinisters-list.vue?vue&type=script&lang=js"
export * from "./modal-sinisters-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports